import React, { useEffect } from "react"
import {
  reduce,
  concat,
  pipe,
  join,
  ifElse,
  identity,
  trim,
  always,
  length,
  keys,
} from "ramda"
import { guardarDesdeUnFormulario } from "../utils/da"
import { makeStyles } from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import InputLabel from "@material-ui/core/InputLabel"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import FormHelperText from "@material-ui/core/FormHelperText"
import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

// #region Constants
// eslint-disable-next-line
const emailregex = /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/i
const FIELD_STATES = { INITIAL: 1, USING: 2, USED: 3 }
const { INITIAL: UNUSED, USING, USED } = FIELD_STATES
const fieldStatesInitialState = {
  sobrenombre: UNUSED,
  correo: UNUSED,
  asunto: UNUSED,
  mensaje: UNUSED,
}
const valuesInitialState = {
  // sobrenombre: localStorage.getItem('nick'),
  // correo: localStorage.getItem('mail'),
  sobrenombre: "",
  correo: "",
  asunto: "",
  mensaje: "",
}
// #endregion

// #region Material UI Styles
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
  marginYMitad: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  camposSuperiores: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  campoSobrenombre: {
    width: "40%",
  },
  campoCorreo: {
    width: "58%",
  },
  margenDerecho: {
    marginRight: "1.5rem",
  },
  // inputLabel: {
  //   textOverflow: 'ellipsis',
  //   whiteSpace: 'nowrap',
  //   overflow: 'hidden',
  //   width: '100%',
  //   color:'grey',
  //   fontStyle:'italic',
  //   fontSize: '1.2rem',
  //   letterSpacing: 1,
  // },

  // input: {
  //   '&::placeholder': {
  //     textOverflow: 'ellipsis !important',
  //     color: 'blue'
  //   },

  // }
}))
// #endregion
const FormularioDeContacto = ({
  asesoramiento,
  contactame,
  subscribite,
  comentario,
  handleClose,
  parentId = 0,
}) => {
  // #region Hooks
  const classes = useStyles()
  const [values, setValues] = React.useState(valuesInitialState)
  const [fieldStates, setFieldStates] = React.useState(fieldStatesInitialState)
  const [snackbarOpen, setSnackbarOpen] = React.useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [mail, setMail] = React.useState(null)
  const [nick, setNick] = React.useState(null)
  useEffect(() => {
    setMail(localStorage.getItem("mail"))
    setNick(localStorage.getItem("nick"))
    if (mail) setValues(v => ({ ...v, correo: localStorage.getItem("mail") }))
    if (nick)
      setValues(v => ({ ...v, sobrenombre: localStorage.getItem("nick") }))
  }, [mail, nick])
  // #endregion

  // #region Quildreen Validations
  function validateForm(data) {
    const errors = []

    if (!data.sobrenombre.trim()) {
      errors.push({
        campo: "sobrenombre",
        mensaje:
          "El nombre es importante. Si está en blanco no sabremos quien eres.",
      })
    }
    if (!emailregex.test(data.correo)) {
      errors.push({
        campo: "correo",
        mensaje:
          "Tiene que ser una dirección de correo electrónico (email address)",
      })
    }
    if (!data.mensaje.trim()) {
      errors.push({
        campo: "mensaje",
        mensaje: "Un mensaje debe tener contenido.",
      })
    }

    return errors
  }
  // #endregion

  // #region Data Functions
  const mapValidationsToErrorsByProp = reduce(
    (errors, validation) => ({
      ...errors,
      [validation.campo]: concat(errors[validation.campo] || [], [
        validation.mensaje,
      ]),
    }),
    {}
  )

  const validate = pipe(validateForm, mapValidationsToErrorsByProp)
  const textFromErrors = ifElse(identity, pipe(join(" "), trim), always(""))
  const isErroneous = valName =>
    fieldStates[valName] === USED &&
    errors[valName] &&
    errors[valName].length > 0
  const textToDisplay = valName =>
    fieldStates[valName] === UNUSED ? "" : textFromErrors(errors[valName])
  // #endregion

  // #region Handlers
  const handleResetButtonClick = () => {
    setValues(valuesInitialState)
    setFieldStates(fieldStatesInitialState)
  }

  const handleChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value })
  }
  const handleBlur = prop => event => {
    setFieldStates({ ...fieldStates, [prop]: USED })
  }
  const handleFocus = prop => event => {
    setFieldStates({ ...fieldStates, [prop]: USING })
  }
  const handleSnackbarClose = () => setSnackbarOpen(false)

  const handleClickOpenDialog = () => {
    setOpenDialog(true)
  }
  const handleOkButtonClick = handleClickOpenDialog

  const resolverReferencia = x =>
    x ? (typeof x === "string" ? Number(x) : x) : null
  const handleOkDialog = () => {
    handleCloseDialog()
    const tipo = values.tipo
      ? values.tipo
      : subscribite
      ? "subscripcion"
      : contactame
      ? "contacto"
      : asesoramiento
      ? "asesoramiento"
      : comentario
      ? "comentario"
      : null

    guardarDesdeUnFormulario({
      ...values,
      referencia: resolverReferencia(parentId),
      tipo,
    }).then(respuesta => {
      localStorage.setItem("nick", values.sobrenombre)
      localStorage.setItem("mail", values.correo)
      setSnackbarOpen(true)
      handleResetButtonClick()
    })
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    handleClose()
  }

  // #endregion

  // #region Setup
  const errors = validate(values)
  const formFullfilled = length(keys(errors)) === 0
  // #endregion
  return (
    <>
      <div name="formulario">
        <div className={comentario ? classes.camposSuperiores : {}}>
          <div className={comentario ? classes.campoSobrenombre : {}}>
            <FormControl
              fullWidth
              className={classes.margin}
              variant="outlined"
            >
              <InputLabel htmlFor="campo-nombre">
                Tu nombre o nickname
              </InputLabel>
              <OutlinedInput
                id="campo-nombre"
                value={values.sobrenombre}
                error={isErroneous("sobrenombre")}
                onChange={handleChange("sobrenombre")}
                onBlur={handleBlur("sobrenombre")}
                onFocus={handleFocus("sobrenombre")}
                labelWidth={128}
              />
              <FormHelperText required id="sobrenombre-helper-text">
                {textToDisplay("sobrenombre")}
              </FormHelperText>
            </FormControl>
          </div>
          <div className={comentario ? classes.campoCorreo : {}}>
            <FormControl
              fullWidth
              className={classes.margin}
              variant="outlined"
            >
              <InputLabel htmlFor="campo-correo">
                Tu dirección de correo electrónico
              </InputLabel>
              <OutlinedInput
                id="campo-correo"
                error={isErroneous("correo")}
                value={values.correo}
                onChange={handleChange("correo")}
                onBlur={handleBlur("correo")}
                onFocus={handleFocus("correo")}
                labelWidth={186}
              />
              <FormHelperText required id="correo-helper-text">
                {textToDisplay("correo")}
              </FormHelperText>
            </FormControl>
          </div>
        </div>

        {asesoramiento ? (
          <FormControl fullWidth className={classes.margin} variant="outlined">
            <InputLabel htmlFor="campo-asunto" className={classes.inputLabel}>
              El motivo del contacto
            </InputLabel>
            <OutlinedInput
              id="campo-asunto"
              error={isErroneous("asunto")}
              value={values.asunto}
              onChange={handleChange("asunto")}
              onBlur={handleBlur("asunto")}
              onFocus={handleFocus("asunto")}
              labelWidth={124}
              className={classes.input}
            />
            <FormHelperText id="asunto-helper-text">
              {textToDisplay("asunto")}
            </FormHelperText>
          </FormControl>
        ) : (
          <></>
        )}
        <FormControl fullWidth className={classes.margin} variant="outlined">
          <InputLabel htmlFor="campo-mensaje">Tu mensaje</InputLabel>
          <OutlinedInput
            id="campo-mensaje"
            error={isErroneous("mensaje")}
            value={values.mensaje}
            onChange={handleChange("mensaje")}
            onBlur={handleBlur("mensaje")}
            onFocus={handleFocus("mensaje")}
            labelWidth={66}
            multiline
            rows={6}
          />
          <FormHelperText id="mensaje-helper-text">
            {textToDisplay("mensaje")}
          </FormHelperText>
        </FormControl>
        <div style={{ position: "relative", height: 40 }}>
          <Button
            variant="outlined"
            color="primary"
            style={{ position: "absolute", right: 180 }}
            onClick={handleClose}
          >
            CERRAR
          </Button>
          <Button
            variant="outlined"
            color="primary"
            style={{ position: "absolute", right: 82 }}
            onClick={handleResetButtonClick}
          >
            CANCELAR
          </Button>
          <Button
            disabled={!formFullfilled}
            variant={formFullfilled ? "contained" : "outlined"}
            color="primary"
            style={{ position: "absolute", right: 0 }}
            onClick={handleOkButtonClick}
          >
            ENVIAR
          </Button>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={10000}
        onClose={handleSnackbarClose}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleSnackbarClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Alert onClose={handleSnackbarClose} severity="info">
          {`¡Muchas gracias por contactarme! ${values.sobrenombre}`}
        </Alert>
      </Snackbar>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿El email es &quot;{values.correo}&quot;?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            CORREGIR
          </Button>
          <Button onClick={handleOkDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default FormularioDeContacto
